import React, { useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, Tooltip } from 'antd';

import TimecardStatsHideIcon from '../../common/icons/TimecardStatsHideIcon';
import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';
import Colors from '../../constants/Colors';

const HIDDEN_STATS_OVERLAY_STYLE = {
  borderRadius: 6,
  overflow: 'hidden',
  border: `1px solid ${Colors.GRAY_200}`,
  marginTop: 4,
  boxShadow: '0px 4px 4.8px 0px #00000033',
};

export default function HiddenStatCardsDropdown({
  hiddenCards,
  onShowStatCard,
}) {
  const [visible, setVisible] = useState(false);
  const blockClose = useRef(false);
  const blockCloseTimer = useRef();

  const onVisibleChange = (next) => {
    if (!next && blockClose.current) return;
    if (next) {
      blockClose.current = true;
      window.clearTimeout(blockCloseTimer.current);
      blockCloseTimer.current = window.setTimeout(() => {
        blockClose.current = false;
      }, 300);
    }
    setVisible(next);
  };

  const overlay = useMemo(() => (
    <div>
      <div
        className="timecard-hidden-stats-dropdown-panel"
        role="presentation"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="timecard-hidden-stats-dropdown-title">Show cards</div>
        {hiddenCards.map(({ key, label }) => (
          <div key={key} className="timecard-hidden-stats-dropdown-item">
            <OnTraccrCheckbox
              label={label}
              value={false}
              textStyle={{
                fontFamily: 'open-sans',
                fontSize: 12,
                lineHeight: '18px',
                color: Colors.GRAY_950,
              }}
              onChange={(checked) => {
                if (checked) onShowStatCard(key);
              }}
            />
          </div>
        ))}
      </div>
    </div>
  ), [hiddenCards, onShowStatCard]);

  return (
    <Dropdown
      visible={visible}
      onVisibleChange={onVisibleChange}
      trigger={['click']}
      placement="bottomLeft"
      overlay={overlay}
      overlayClassName="timecard-hidden-stats-dropdown"
      overlayStyle={HIDDEN_STATS_OVERLAY_STYLE}
    >
      <span style={{ display: 'inline-flex' }}>
        <Tooltip title="Show hidden cards">
          <button
            type="button"
            className="timecard-header-stats-show-hidden"
            aria-label="Show hidden cards"
            onClick={(event) => event.preventDefault()}
            onMouseDown={(event) => event.preventDefault()}
          >
            <TimecardStatsHideIcon width={14} height={14} />
          </button>
        </Tooltip>
      </span>
    </Dropdown>
  );
}

HiddenStatCardsDropdown.propTypes = {
  hiddenCards: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  onShowStatCard: PropTypes.func.isRequired,
};
